module.exports = __webpack_public_path__ + "app-static/img/p_02.31e095e9.jpg";